export default {
  // 导航树
  menuPermissionTree: '/developer/api/menu/permissionTree',
  // 全量应用
  getAllApplicationList: '/developer/api/application/selectAll',
  // 角色
  roleList: '/developer/api/role/list',
  roleEdit: '/developer/api/role/addOrUpdate',
  roleDelete: '/developer/api/role/delete',
  // 子账号
  subAccountList: '/developer/api/subAccount/list',
  subAccountEdit: '/developer/api/subAccount/addOrUpdate',
  subAccountDelete: '/developer/api/subAccount/delete',
  subAccountStatus: '/developer/api/subAccount/toggleStatus'
};
